@if (loading$ | async) {
    <div class="w-full h-full flex justify-center items-center">
        <mat-spinner></mat-spinner>
    </div>
}
@if (shipment$ | async; as shipment) {
    <div class="p-6">
        <div class="flex flex-col sm:flex-row gap-2 mb-2">
            <div class="flex grow sm:flex-none sm:w-64 justify-center pb-2">
                @if (shipment.quote) {
                    <app-quote-card [shipment]="shipment" [quote]="shipment.quote"></app-quote-card>
                }
            </div>
            <div class="flex grow">
                <dl>
                    <dt i18n>Carrier Tracking Number</dt>
                    @if (shipment.trackingNumber) {
                        <dd class="text-lg">{{ shipment.trackingNumber }}</dd>
                    } @else {
                        <dd i18n>No tracking number recorded</dd>
                    }
                    <dt i18n>Created At</dt>
                    <dd>{{ shipment.createdAt | date }}</dd>
                    <dt i18n>Shipment Date</dt>
                    <dd>{{ shipment.shipmentDate }}</dd>
                    <dt i18n>User</dt>
                    <dd>{{ shipment.username }}</dd>
                    <dt i18n>Courier</dt>
                    <dd>{{ shipment.quote.courierName }}</dd>
                </dl>
            </div>
            <div class="flex w-64">
                <dl>
                    <dt i18n>Status</dt>
                    <dd class="mb-2">
                        <app-shipment-indicator [defaultState]="shipment.statusCode"></app-shipment-indicator>
                    </dd>
                    @if (showPickupDetail(shipment)) {
                        <dt>{{ pickupSectionTitle$ | async }}</dt>
                    }
                    @if (showPickupDetail(shipment)) {
                        <dd>
                            <div>{{ pickupReference$ | async }}</div>
                        </dd>
                    }
                    @if (showPickupBooking(shipment)) {
                        <dt>Booking</dt>
                    }
                    @if (showPickupBooking(shipment)) {
                        <dd>
                            {{ shipment.pickup.date }}
                            @if (shipment.pickup.startTime && shipment.pickup.endTime) {
                                <span>
                  &#64; {{ shipment.pickup.startTime }} - {{ shipment.pickup.endTime }}
                </span>
                            }
                        </dd>
                    }
                </dl>
            </div>
        </div>
        <div class="flex flex-col md:flex-row gap-4">
            <mat-card class="w-full">
                <mat-card-content>
                    <dl>
                        <dt i18n>Shipper</dt>
                        <dd>
                            <app-card-display [card]="shipment.shipper"></app-card-display>
                        </dd>
                    </dl>
                </mat-card-content>
            </mat-card>
            <mat-card class="w-full">
                <mat-card-content>
                    <dl>
                        <dt i18n>Consignee</dt>
                        <dd>
                            <app-card-display [card]="shipment.destination"></app-card-display>
                        </dd>
                    </dl>
                </mat-card-content>
            </mat-card>
        </div>
        <mat-card class="mt-4">
            <mat-card-content>
                <div class="flex flex-col md:flex-row gap-4 mb-2">
                    <div class="flex grow">
                        <dl class="w-full">
                            <dt i18n>Price</dt>
                            <dd>
                                <app-price-breakdown
                                        [price]="shipment.quote.customer"
                                        [comparison]="shipment.quote.list"
                                        [comparisonRatio]="shipment.quote.listCurrencyConversion">
                                </app-price-breakdown>
                            </dd>
                        </dl>
                    </div>
                    @if (shipment.quote.cost) {
                        <div class="flex grow">
                            <dl class="w-full">
                                <dt i18n>Cost</dt>
                                <dd>
                                    <app-price-breakdown
                                            [price]="shipment.quote.cost"
                                            [comparison]="shipment.quote.list"
                                            [comparisonRatio]="shipment.quote.listCurrencyConversion">
                                    </app-price-breakdown>
                                </dd>
                            </dl>
                        </div>
                    }
                    @if (shipment.quote.reseller) {
                        <div class="flex grow">
                            <dl class="w-full">
                                <dt i18n>Reseller</dt>
                                <dd>
                                    <app-price-breakdown
                                            [price]="shipment.quote.reseller">
                                    </app-price-breakdown>
                                </dd>
                            </dl>
                        </div>
                    }
                    @if (shipment.quote.list) {
                        <div class="flex grow">
                            <dl class="w-full">
                                <dt i18n>List</dt>
                                <dd>
                                    <app-price-breakdown
                                            [price]="shipment.quote.list"
                                    >
                                    </app-price-breakdown>
                                </dd>
                            </dl>
                        </div>
                    }
                </div>
            </mat-card-content>
        </mat-card>
        @if (documentsForShipment(shipment).length > 0) {
            <mat-card class="mt-4">
                <mat-card-content>
                    <div class="flex mb-2">
                        <div class="col-md-6">
                            <dl>
                                <dt i18n>Documents</dt>
                                <dd class="flex flex-row align-top">
                                    @for (doc of documentsForShipment(shipment); track doc) {
                                        <span>
                                            <app-document-link [document]="doc"></app-document-link>
                                         </span>
                                    }
                                </dd>
                            </dl>
                        </div>
                    </div>
                </mat-card-content>
            </mat-card>
        }
        <mat-card class="mt-4">
            <mat-card-content>
                <table class="table-auto w-full details mb-2">
                    <thead>
                    <tr class="">
                        <th i18n>Package Detail</th>
                        <th></th>
                        <th i18n>Tracking</th>
                        <th i18n>Weight</th>
                        <th i18n>Dimensions</th>
                    </tr>
                    </thead>
                    <tbody>
                        @for (pkg of shipment.packages; track pkg) {
                            <tr>
                                <td>
                                    @if (pkg.description) {
                                        {{ pkg.description }}
                                    }
                                    @if (!pkg.description) {
                                        <span class="muted">(no description)</span>
                                    }
                                </td>
                                <td>
                                    @for (doc of documentsForPackage(shipment, pkg.id); track doc) {
                                        <app-document-link
                                                [document]="doc"></app-document-link>
                                    }
                                </td>
                                <td>{{ pkg.trackingNumber }}</td>
                                <td>{{ pkg.weight | weight:shipment.weightUnit }}</td>
                                <td>{{ pkg.width | dimension:shipment.dimensionUnit }} &times;
                                    {{ pkg.height | dimension:shipment.dimensionUnit }} &times;
                                    {{ pkg.length | dimension:shipment.dimensionUnit }}
                                </td>
                            </tr>
                        }
                    </tbody>
                </table>
            </mat-card-content>
        </mat-card>
        <mat-card class="mt-4">
            <mat-card-content>
                <app-shipment-tracking [shipment]="shipment"></app-shipment-tracking>
            </mat-card-content>
        </mat-card>
    </div>
}
